import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=6d368e30&scoped=true&"
import script from "./TaxSummary.vue?vue&type=script&lang=js&"
export * from "./TaxSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxSummary.vue?vue&type=style&index=0&id=6d368e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d368e30",
  null
  
)

export default component.exports